import { api, API, formatApiError } from "@/lib/api";
import { toast } from "sonner";

// Fetches a short-lived signed URL on demand, then opens the PDF.
// Nothing shareable/bookmarkable is ever rendered into the DOM.
export const FileLink = ({ fileId, className, children, testId }) => {
  const open = async () => {
    try {
      const { data } = await api.get(`/files/${fileId}/signed-url`);
      window.open(`${API}/files/${fileId}?token=${data.token}`, "_blank", "noopener,noreferrer");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "You cannot access this file");
    }
  };
  return (
    <button type="button" data-testid={testId} onClick={open} className={className}>
      {children}
    </button>
  );
};
